<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg
          id="header"
          class="bd-placeholder-img mr-2 rounded"
          width="28"
          height="28"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
          aria-label="Placeholder: 32x32"
        >
          <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{ pageTitle }}</h5>
      </div>
      <div class="col-3">
        <button
          id="backBtn"
          type="button"
          class="btn-sm btn-outline-info btn_right"
          v-on:click="back"
        >
          一覧へ戻る
        </button>
        <button
          id="destroyBtn"
          type="button"
          class="btn-sm btn-outline-danger btn_right"
          v-on:click="destroy"
        >
          削除する
        </button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1"></div>
      <div class="col-8">
        <div class="form-group">
          <div class="row" style="height: 90px; padding: 10px 0">
            <div class="col-2">
              <label>タイトル</label>
            </div>
            <div class="col-8">
              {{ $route.params.key }}
            </div>
          </div>
          <div class="row" style="height: 130px">
            <div class="col-2">
              <label>イメージ</label>
            </div>
            <div class="col-3">
              <img class="card-img" src="/card-image.svg" v-show="!isBlobUrl" />
              <div
                class="trim-circle"
                :style="{ backgroundImage: 'url(' + blobUrl + ')' }"
                v-show="isBlobUrl"
              ></div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sessions } from '../../mixin/session';
import { path } from '../../mixin/path';
import { headers } from '../../mixin/headers';

export default {
  name: 'Detail',
  mixins: [sessions, path, headers],
  props: ['realms', 'serviceName'],
  data: function () {
    return {
      message: '',
      blobUrl: '',
      hospitalId: null
    };
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0;
    },
    isBlobUrl: function () {
      return this.blobUrl.length > 0;
    },
    pageTitle: function () {
      return 'アイコン 詳細';
    }
  },
  mounted() {
    if (this.$store.getters.hospital.id !== 0) {
      this.hospitalId = this.$store.getters.hospital.id;
      this.getProfileImage();
    }
  },
  methods: {
    back() {
      this.$router.replace(
        this.replacePath(this.$cognito, this.realms, '/common/icon/index')
      );
    },
    destroy() {
      if (confirm('削除してもよろしいですか?')) {
        this.$cognito
          .isAuthenticated()
          .then((session) => {
            if (session) {
              var accessToken = this.getAccessToken(this.$cognito, session);
              var fileName = this.$route.params.key;
              axios
                .delete(
                  `/api/icon/management/${this.$store.getters.hospital.id}/${this.$store.getters.hospital.code}/icons/${fileName}`,
                  {
                    headers: this.headers(accessToken)
                  }
                )
                .then((response) => {
                  var res = response.data;
                  if (res.errorMessage) {
                    this.message = res.errorMessage;
                  } else {
                    alert('削除されました。');
                    this.back();
                  }
                })
                .catch((err) => {
                  this.message = err.message;
                });
            }
          })
          .catch((err) => {
            this.message = err.message;
          });
      }
    },
    getProfileImage() {
      // get profile image
      this.$cognito.isAuthenticated().then((session) => {
        if (!session) {
          return;
        }
        var accessToken = this.getAccessToken(this.$cognito, session);
        axios
          .get(
            `/api/icon/management/${this.$store.getters.hospital.id}/${this.$store.getters.hospital.code}/icons/${this.$route.params.key}`,
            {
              headers: this.headers(accessToken),
              responseType: 'blob'
            }
          )
          .then((response) => {
            var res = response.data;
            if (res.errorMessage) {
              this.message = res.errorMessage;
            } else {
              this.blobUrl = URL.createObjectURL(res);
            }
          })
          .catch((err) => {
            this.message = err.message;
          });
      });
    }
  }
};
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float: right;
}
#destroyBtn {
  margin-right: 10px;
}
.alert-margin {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.card-img {
  width: 350px;
  height: 350px;
  border: 2px #007bff solid;
}
.trim-circle {
  width: 350px;
  height: 350px;
  border: 2px #007bff solid;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
</style>
